// A conta da mesa FORA do Fechar mesa — comanda do painel e cartão da mesa
// (dono, 24/09/2026: "pago um produto, volto a mesa para aberta, ele fica
// mostrando como pago e o restante da mesa em aberto"). Lê `mesa.pagamentos`,
// o mesmo registro que o Fechar mesa grava (`montarPagamentos`) e que o
// servidor lê para a comanda do celular (`api/v1/mesa_qr/conta.py`): as três
// telas mostram a mesma conta.
//
// Já pago = preço cheio dos quitados + parciais dos não quitados +
// `partial_paid` (pago "por valor", sem produto) — igual ao Pago/Restante do
// Fechar mesa.
import { valorItem } from "./divisao";

const centavos = (v) => Math.round((Number(v) || 0) * 100);
const reais = (c) => Math.round(c) / 100;

export function lerPagamentos(mesa) {
  let pag = mesa?.pagamentos;
  if (typeof pag === "string") {
    try { pag = JSON.parse(pag); } catch { pag = null; }
  }
  return pag && typeof pag === "object" ? pag : {};
}

// Chave do produto: `cartItemId`, ou "i<posição sem os riscados>" (a mesma do
// Fechar mesa e do servidor). Texto sempre: o PIX do Mesa QR grava como texto.
export const chaveNaConta = (item, posicao) => String(item.cartItemId || `i${posicao}`);

/**
 * `{ porChave, total, pago, restante }`. `porChave[chave]` = `{ valor,
 * quitado, forma, parcial, restante }` de cada produto não riscado.
 */
export function contaDaMesa(mesa) {
  const pag = lerPagamentos(mesa);
  const quitados = new Map(
    (Array.isArray(pag.paid_items) ? pag.paid_items : [])
      .filter((p) => p && typeof p === "object")
      .map((p) => [String(p.key), p.label || ""]),
  );
  const parciais = pag.parciais && typeof pag.parciais === "object" ? pag.parciais : {};
  const porChave = {};
  let totalC = 0;
  let pagoC = 0;
  (Array.isArray(mesa?.items) ? mesa.items : [])
    .filter((i) => i && !i.deleted)
    .forEach((item, posicao) => {
      const chave = chaveNaConta(item, posicao);
      const valorC = centavos(valorItem(item));
      const quitado = quitados.has(chave);
      const parcialC = quitado ? 0 : Math.min(valorC, centavos(parciais[chave]?.valor));
      totalC += valorC;
      pagoC += quitado ? valorC : parcialC;
      porChave[chave] = {
        valor: reais(valorC),
        quitado,
        forma: quitado ? quitados.get(chave) : null,
        parcial: reais(parcialC),
        restante: reais(quitado ? 0 : valorC - parcialC),
      };
    });
  pagoC = Math.min(totalC, pagoC + centavos(pag.partial_paid));
  return { porChave, total: reais(totalC), pago: reais(pagoC), restante: reais(totalC - pagoC) };
}

/** Situação de pagamento de um produto da comanda (`null` = nada pago). */
export function pagoDoItem(conta, item, posicao) {
  const p = conta?.porChave?.[chaveNaConta(item, posicao)];
  return p && (p.quitado || p.parcial > 0) ? p : null;
}
